import { Grid, Box } from "@mui/material";
import React, { Component } from "react";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { connect } from "react-redux";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
} from "../mapRedux/mapReduxProps";
import {
  getTaxNumFromStr,
  getTaxableFromValue,
  isValidItem,
  roundOff,
  setTaxPaidRate,
  getRoundOff,
} from "../SystemUtility/SystemUtility";
import { withRouter } from "../HOC/withRouter";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import SetTaxPaidRate from "./SetTaxPaidRate";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import ItemMaster from "./ItemMaster";
import { fetchOrder } from "./API";

export class OrderItemEntry extends Component {
  state = {
    ItemNameList: [],
    TaxNameList: [],
    TaxName: [],
    edit_ordersrno: "",
    columns: [
      { id: "Action", label: "Search", name: "Search" },
      // { id: 'bint_srno', label: 'SR NO' },
      { id: "orderno", label: "Order No" },
      { id: "date", label: "Date" },
      { id: "company", label: "Company" },
      { id: "totalamount", label: "Total Amount" },
    ],
    formData: {
      txtSrNo: "",
      cmbItemName: "",
      txtHSN: "",
      cmbPacking: "",
      txtQty: "",
      txtPurRate: "",
      txtRate: "",
      txtBasicAmt: "",
      txtDis: "",
      txtDisAmt: "",
      txtTaxable: "",
      cmbTaxName: "",
      txtCGST: "",
      txtSGST: "",
      txtIGST: "",
      txtTotalAmount: "",
      txtRemark: "",
      txtRate: "",
    },
    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Order Item Entry";
    this.props.setActiveMenu("OrderEntry");
    this.onFormLoad();
  }
  //#endregion Component

  //#region Function

  calBasicAmount = () => {
    let txtBasicAmt = 0;
    if (
      Number(this.state.formData.txtRate) > 0 &&
      Number(this.state.formData.txtQty) > 0
    ) {
      txtBasicAmt =
        Number(this.state.formData.txtRate) *
        Number(this.state.formData.txtQty);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtBasicAmt,
          txtTaxable: txtBasicAmt,
        },
      },
      () => {
        this.calDisAmount();
      }
    );
  };

  calDisAmount = () => {
    let txtDisAmt = 0,
      txtTaxable = 0;
    if (Number(this.state.formData.txtDis) > 0) {
      txtDisAmt =
        (Number(this.state.formData.txtBasicAmt) *
          Number(this.state.formData.txtDis)) /
        100;
      txtTaxable = Number(this.state.formData.txtBasicAmt) - txtDisAmt;
      // console.log('txtTaxable from If', txtTaxable)
    } else if (Number(this.state.formData.txtDisAmt) > 0) {
      txtTaxable =
        Number(this.state.formData.txtBasicAmt) -
        Number(this.state.formData.txtDisAmt);
      // console.log('txtTaxable from Else if, txtBasicAmt, txtDisAmt', txtTaxable, this.state.formData.txtBasicAmt, this.state.formData.txtDisAmt)
    } else {
      txtTaxable = Number(this.state.formData.txtBasicAmt);
    }
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtDisAmt,
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
        // this.calTotalAmount()
      }
    );
  };

  getTaxableBasedOnDisAmt = () => {
    let txtTaxable =
      Number(this.state.formData.txtBasicAmt) -
      Number(this.state.formData.txtDisAmt);
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtDis: "",
          txtTaxable,
        },
      },
      () => {
        this.calTax_CSGT_SGST_IGST();
      }
    );
  };

  calTax_CSGT_SGST_IGST = () => {
    let txtIGST = 0,
      txtSGST = 0,
      txtCGST = 0;
    if (this.state.formData.cmbTaxName.length > 0) {
      const txtTaxable = Number(this.state.formData.txtTaxable),
        cmbTaxName = getTaxNumFromStr(this.state.formData.cmbTaxName);
      //Number(this.state.formData.cmbTaxName.substring(0, this.state.formData.cmbTaxName.length - 1))
      let txtCGST = 0,
        txtSGST = 0,
        txtIGST = 0;
      if (Number(txtTaxable) >= 0 && Number(cmbTaxName) >= 0) {
        txtCGST = (txtTaxable * (cmbTaxName / 2)) / 100;
        txtCGST = txtCGST.toFixed(2);
        txtSGST = txtCGST;
        // console.log("this.props.CustomerStateCode",this.props.CustomerStateCode);
        // console.log("localstorage",localStorage.getItem('CompStateCode'));
        if (
          this.props.CustomerStateCode != localStorage.getItem("CompStateCode")
        ) {
          txtIGST = Number(txtCGST) + Number(txtSGST);
          txtCGST = 0;
          txtSGST = 0;
        }
      }
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtCGST: Number(txtCGST),
            txtSGST: Number(txtSGST),
            txtIGST: Number(txtIGST),
          },
        },
        () => {
          // console.log("txtCGST", txtCGST);
          // console.log("txtSGST", txtSGST);
          // console.log("txtIGST", txtIGST);
          // console.log("this.state.formData.txtCGST", this.state.formData.txtCGST);
          // console.log("this.state.formData.txtSGST", this.state.formData.txtSGST);
          // console.log("this.state.formData.txtIGST", this.state.formData.txtIGST);
          this.calTotalAmount();
        }
      );
    }
  };

  calTotalAmount = () => {
    let txtTotalAmount = 0;
    if (Number(this.state.formData.txtTaxable) > 0) {
      txtTotalAmount =
        Number(this.state.formData.txtTaxable) +
        Number(this.state.formData.txtSGST) +
        Number(this.state.formData.txtCGST) +
        Number(this.state.formData.txtIGST);
      txtTotalAmount = txtTotalAmount.toFixed(2);
    }
    this.setState({
      formData: {
        ...this.state.formData,
        txtTotalAmount,
      },
    });
  };

  calcAmtBasedOnTotalAmountInReverse = () => {
    let txtTotalAmount = Number(this.state.formData.txtTotalAmount),
      cmbTaxName = this.state.formData.cmbTaxName,
      numTax = getTaxNumFromStr(cmbTaxName),
      txtTaxable = getTaxableFromValue(numTax, txtTotalAmount),
      txtBasicAmt =
        Number(this.state.formData.txtDisAmt) > 0
          ? txtTaxable - Number(this.state.formData.txtDisAmt)
          : txtTaxable,
      txtRate =
        Number(this.state.formData.txtQty) > 0
          ? roundOff(txtBasicAmt / Number(this.state.formData.txtQty), 2)
          : "";

    this.setState({
      formData: {
        ...this.state.formData,
        txtTaxable,
        txtBasicAmt,
        txtRate,
      },
    });
  };

  onTpTextChange = (NewTP) => {
    let txtRate = 0;
    if (Number(NewTP) > 0) {
      // console.log("NewTP", NewTP);
      let numTax = getTaxNumFromStr(this.state.formData.cmbTaxName);
      // console.log("numTax", numTax);
      txtRate = setTaxPaidRate(
        numTax,
        NewTP,
        Number(this.state.formData.txtQty)
      );
      // console.log("txtRate", txtRate);
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    } else {
      this.setState(
        {
          formData: {
            ...this.state.formData,
            txtRate,
          },
        },
        () => {
          this.calBasicAmount();
        }
      );
    }
  };

  // resetAmount = (
  //   txtTaxable,
  //   txtCGST,
  //   txtSGST,
  //   txtIGST,
  //   txtGrandTotal,
  //   txtDiscount,
  //   edit_ordersrno
  // ) => {
  //   this.setState(
  //     {
  //       formData: {
  //         ...this.state.formData,
  //         txtTaxable,
  //         txtCGST,
  //         txtSGST,
  //         txtIGST,
  //         txtGrandTotal,
  //         txtDiscount,
  //         edit_ordersrno,
  //       },
  //     },
  //     () => {
  //       // console.log("this.state.formData", this.state.formData);
  //       this.calNetAmount();
  //     }
  //   );
  // };

  calNetAmount = () => {
    // console.log(Number(this.state.formData.txtGrandTotal))
    // console.log((this.state.formData.txtTotalAmount))
    let txtTotalAmount = Number(this.state.formData.txtGrandTotal),
      txtRoundOff = 0;
    // console.log(txtTotalAmount)
    let arrNetPayment = getRoundOff(txtTotalAmount);
    // console.log(arrNetPayment)
    txtTotalAmount = arrNetPayment["roff_number"];
    // console.log(txtTotalAmount)
    txtRoundOff = arrNetPayment["roff"];
    // console.log(txtRoundOff)
    this.setState({
      formData: {
        ...this.state.formData,
        txtTotalAmount,
        txtRoundOff,
        // chkReceiptGenerated,
      },
    });
  };

  validateOrderItem = () => {
    let result = false;
    if (this.state.formData.cmbItemName.length <= 0) {
      this.props.toastErrorMsg("Select Item Name", "cmbItemName");
    } else if (
      !isValidItem(
        this.state.ItemNameList,
        "vac_itemname",
        this.state.formData.cmbItemName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Item Name", "cmbItemName");
    } else if (this.state.formData.cmbPacking.length <= 0) {
      this.props.toastErrorMsg("Select Packing Name", "cmbPacking");
    } else if (
      !isValidItem(
        this.state.ItemNameList,
        "vac_unit",
        this.state.formData.cmbPacking
      )
    ) {
      this.props.toastErrorMsg("Select Valid Packing Name", "cmbPacking");
    } else if (this.state.formData.txtQty <= 0) {
      this.props.toastErrorMsg("Enter Quantity", "txtQty");
    } else if (this.state.formData.txtRate <= 0) {
      this.props.toastErrorMsg("Enter Rate", "txtRate");
    } /* else if (this.state.formData.txtDis < 0) {
      this.props.toastErrorMsg("Enter Discount (%)", "txtDis");
    } else if (this.state.formData.txtDisAmt < 0) {
      this.props.toastErrorMsg("Enter Discount Amount", "txtDisAmt");
    } */ else if (this.state.formData.cmbTaxName.length <= 0) {
      this.props.toastErrorMsg("Select Tax Name", "cmbTaxName");
    } else if (
      !isValidItem(
        this.state.TaxNameList,
        "vac_taxname",
        this.state.formData.cmbTaxName
      )
    ) {
      this.props.toastErrorMsg("Select Valid Tax Name", "cmbTaxName");
    } else {
      result = true;
    }
    return result;
  };

  clearInfo = () => {
    this.setState(
      {
        formData: {
          ...this.state.formData,
          txtSrNo: "",
          cmbItemName: "",
          txtHSN: "",
          cmbPacking: "",
          // txtStock: "",
          txtPurRate: "",
          txtQty: "",
          txtRate: "",
          txtBasicAmt: "",
          txtDis: "",
          txtDisAmt: "",
          txtTaxable: "",
          cmbTaxName: "",
          txtCGST: "",
          txtSGST: "",
          txtIGST: "",
          txtTotalAmount: "",
          txtRemark: "",
        },
      },
      () => {
        document.getElementById("cmbItemName").focus();
      }
    );
  };

  onDeleteBtnClick = () => {
    if (Number(this.state.formData.txtSrNo) > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Item : " +
              this.state.formData.cmbItemName +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.deleteOrderItem(
                this.props.bint_acyear,
                this.props.bint_acid,
                this.state.edit_ordersrno,
                this.state.formData.txtSrNo
              );
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );
        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("There are no item to delete", "cmbItemName");
    }
  };

  deleteOrderItem = (bint_acyear, bint_acid, bint_ordersrno, bint_itemsrno) => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "DeleteOrderItem",
        bint_acyear: bint_acyear,
        bint_acid: bint_acid,
        edit_ordersrno: bint_ordersrno,
        bint_itemsrno: bint_itemsrno,
      };
      fetchOrder(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            rowsCount = 0;
          let dec_basicamt = 0,
            dec_disamt = 0,
            dec_taxable = 0,
            dec_cgstamt = 0,
            dec_sgstamt = 0,
            dec_igstamt = 0,
            dec_totalamt = 0,
            ItemData = [];
          if (res.data.ItemData && res.data.ItemData.length > 0) {
            rows = res.data.ItemData;
            rowsCount = rows.length;
          }
          if (res.data.OrderList) {
            bint_ordersrno = res.data.OrderList[0].bint_ordersrno;
            dec_disamt = Number(res.data.OrderList[0].dec_discountamount);
            dec_taxable = Number(res.data.OrderList[0].dec_taxable);
            dec_cgstamt = Number(res.data.OrderList[0].dec_cgst);
            dec_sgstamt = Number(res.data.OrderList[0].dec_sgst);
            dec_igstamt = Number(res.data.OrderList[0].dec_igst);
            dec_totalamt = Number(res.data.OrderList[0].dec_grandtotal);
          }
          this.setState(
            {
              ARD: null,
              dataLoadStatus,
            },
            () => {
              this.props.resetAmount(
                dec_taxable,
                dec_cgstamt,
                dec_sgstamt,
                dec_igstamt,
                dec_totalamt,
                0,
                0
              );
              this.props.refreshOrderItemList(rows, rowsCount);
              this.clearInfo();
            }
          );
        })
        .catch((error) => {
          console.log("Unknown error occurred in deleteOrderList.", error);
        });
    });
    return true;
  };

  saveOrderItem = () => {
    // if (this.props.userPrivilege.Sales != 'R') {
    // console.log("faizan")
    if (this.validateOrderItem()) {
      const dataLoadStatus = false;
      this.props.notifyProcessing();
      this.setState({ dataLoadStatus }, () => {
        const reqData = {
          Op: "SaveOrder_Item",
          bint_ci: localStorage.getItem("CI"),
          bint_acyear: this.props.bint_acyear,
          bint_acid: this.props.bint_acid,
          vac_company: this.props.cmbCompany,
          bint_ordersrno: this.state.edit_ordersrno,
          dat_orderdate: this.props.dtpDate,
          vac_customer: this.props.vac_customer,
          vac_ledgername:
            this.props.vac_ledgername && this.props.vac_ledgername.length > 0
              ? this.props.vac_ledgername
              : "",
          vac_referencename:
            this.props.vac_referencename &&
            this.props.vac_referencename.length > 0
              ? this.props.vac_referencename
              : "",
          vac_groupname: this.props.vac_groupname,
          dec_discountamount: this.props.txtDiscount,
          dec_taxable: this.props.txtTaxable,
          dec_cgst: this.props.txtCGST,
          dec_sgst: this.props.txtSGST,
          dec_igst: this.props.txtIGST,
          dec_grandtotal: this.props.txtGrandTotal,
          dec_roundoff: this.props.txtRoundOff,
          dec_totalamount: this.props.txtTotalAmount,
          vac_remark: this.props.txtRemark,
          ItemData: [
            {
              bint_itemsrno: this.state.formData.txtSrNo,
              vac_itemname: this.state.formData.cmbItemName,
              vac_hsncode: this.state.formData.txtHSN,
              vac_unit: this.state.formData.cmbPacking,
              dec_qty: this.state.formData.txtQty,
              dec_rate: this.state.formData.txtRate,
              dec_basicamt: this.state.formData.txtBasicAmt,
              dec_disper: this.state.formData.txtDis,
              dec_disamt: this.state.formData.txtDisAmt,
              dec_taxable: this.state.formData.txtTaxable,
              vac_taxname: this.state.formData.cmbTaxName,
              dec_cgstamt: this.state.formData.txtCGST,
              dec_sgstamt: this.state.formData.txtSGST,
              dec_igstamt: this.state.formData.txtIGST,
              dec_totalamt: this.state.formData.txtTotalAmount,
              vac_remark: this.state.formData.txtRemark,
            },
          ],
        };

        fetchOrder(reqData)
          .then((res) => {
            // console.log("reqData", reqData);
            this.props.updateProcessing(res.data.msgType, res.data.message);
            if (res.data.msgType === "success") {
              let dec_basicamt = 0,
                dec_disamt = 0,
                dec_taxable = 0,
                dec_cgstamt = 0,
                dec_sgstamt = 0,
                dec_igstamt = 0,
                dec_totalamt = 0,
                OrderItemData = [],
                bint_ordersrno = 0;
              if (res.data.ItemData) {
                OrderItemData = res.data.ItemData;
              }
              // console.log(OrderItemData);
              // console.log("res.data.ItemData", res.data.ItemData);
              if (res.data.OrderList) {
                bint_ordersrno = res.data.OrderList[0].bint_ordersrno;
                dec_disamt = Number(res.data.OrderList[0].dec_discountamount);
                dec_taxable = Number(res.data.OrderList[0].dec_taxable);
                dec_cgstamt = Number(res.data.OrderList[0].dec_cgst);
                dec_sgstamt = Number(res.data.OrderList[0].dec_sgst);
                dec_igstamt = Number(res.data.OrderList[0].dec_igst);
                dec_totalamt = Number(res.data.OrderList[0].dec_grandtotal);
              }
              this.setState(
                {
                  edit_ordersrno: bint_ordersrno,
                },
                () => {
                  // console.log("edit_ordersrno", this.state.edit_ordersrno);
                  this.props.resetAmount(
                    dec_taxable,
                    dec_cgstamt,
                    dec_sgstamt,
                    dec_igstamt,
                    dec_totalamt,
                    dec_disamt,
                    bint_ordersrno
                  );
                  this.props.refreshOrderItemList(OrderItemData);
                  this.clearInfo();
                }
              );
            }
          })
          .catch((error) => {
            console.log("Unknown error occurred in saveSalesItem.", error);
          });
      });
      // }
    }
  };

  onAddClickItem = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          alertMessage=<ItemMaster
            OpenFromSalesItem="Yes"
            refreshItemNameList={this.refreshItemNameList}
          />
          defaultOpenDialog={true}
          handleOnClickNo={this.props.getItemList}
        />
      );
      this.setState({ ARD });
    });
  };

  refreshItemNameList = (ItemNameList) => {
    this.setState({
      ItemNameList,
    });
  };

  onFormLoad = () => {
    // console.log("this.props", this.props);
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      let ItemNameList = [],
        TaxNameList = [],
        edit_ordersrno = 0;
      if (this.props.ItemNameList && this.props.TaxNameList) {
        // console.log("this.props.ItemNameList", this.props.ItemNameList);
        ItemNameList = this.props.ItemNameList;
        TaxNameList = this.props.TaxNameList;
        edit_ordersrno = this.props.edit_ordersrno;
        // console.log("this.props.edit_ordersrno", this.props.edit_ordersrno);
        this.setState(
          {
            ItemNameList,
            TaxNameList,
            edit_ordersrno,
            dataLoadStatus: true,
          },
          () => {}
        );
      }
      if (this.props.bint_itemsrno && Number(this.props.bint_itemsrno) > 0) {
        if (
          this.props.EditOrderItemData &&
          this.props.EditOrderItemData.length > 0
        ) {
          let EditOrderItemData = this.props.EditOrderItemData;
          this.setState(
            {
              formData: {
                ...this.state.formData,
                txtSrNo: EditOrderItemData[0].bint_itemsrno,
                cmbItemName: EditOrderItemData[0].vac_itemname,
                // cmbStoreName: EditOrderItemData[0].vac_storename,
                cmbPacking: EditOrderItemData[0].vac_unit,
                // txtStock: EditOrderItemData[0].,
                // txtPurRate: EditOrderItemData[0].,
                cmbCustomer: EditOrderItemData[0].vac_customer,
                txtHSN: EditOrderItemData[0].vac_hsncode,
                txtRate: EditOrderItemData[0].dec_rate,
                txtQty: EditOrderItemData[0].dec_qty,
                txtBasicAmt: EditOrderItemData[0].dec_basicamt,
                txtDis: EditOrderItemData[0].dec_disper,
                txtDisAmt: EditOrderItemData[0].dec_disamt,
                txtTaxable: EditOrderItemData[0].dec_taxable,
                cmbTaxName: EditOrderItemData[0].vac_taxname,
                txtCGST: EditOrderItemData[0].dec_cgstamt,
                txtSGST: EditOrderItemData[0].dec_sgstamt,
                txtIGST: EditOrderItemData[0].dec_igstamt,
                txtTotalAmount: EditOrderItemData[0].dec_totalamt,
                txtRemark: EditOrderItemData[0].vac_remark,
              },
            },
            () => {
              document.getElementById("cmbItemName").focus();
            }
          );
        }
      }
    });
    document.getElementById("cmbItemName").focus();
  };

  handleOnChange = (e) => {
    this.setState(
      {
        formData: { ...this.state.formData, [e.target.name]: e.target.value },
      },
      () => {
        if (e.target.name == "cmbItemName" || e.target.name == "cmbPacking") {
          if (e.target.name == "cmbItemName") {
            this.setItemDetail();
            // this.getRate()//Load HSN, Packing, Tax Name
          }
          // this.getPurchaseRate()
        } else if (e.target.name == "txtRate" || e.target.name == "txtQty") {
          this.calBasicAmount();
        } else if (e.target.name == "txtDis") {
          this.calDisAmount();
        } else if (e.target.name == "txtDisAmt") {
          this.getTaxableBasedOnDisAmt();
        } else if (e.target.name == "cmbTaxName") {
          this.calTax_CSGT_SGST_IGST();
        } else if (e.target.name == "txtTotalAmount") {
          this.calcAmtBasedOnTotalAmountInReverse();
        }
      }
    );
  };

  setItemDetail = () => {
    if (
      this.state.ItemNameList.length > 0 &&
      this.state.formData.cmbItemName.length > 0
    ) {
      this.state.ItemNameList.map((row) => {
        if (row.vac_itemname == this.state.formData.cmbItemName) {
          this.setState(
            {
              formData: {
                ...this.state.formData,
                cmbPacking: row.vac_unit,
                txtHSN: row.vac_hsncode,
                txtRate: Number(row.dec_salesrate),
                cmbTaxName: row.vac_taxname,
              },
            },
            () => {
              return;
            }
          );
        }
      });
    }
  };

  openTaxPaidRateARD = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // labelAgree='Set'
          alertMessage={
            <SetTaxPaidRate
              onTpTextChange={this.onTpTextChange}
              closeTaxPaidRateARD={this.closeTaxPaidRateARD}
            />
          }
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  closeTaxPaidRateARD = () => {
    let ARD = null;
    this.setState({ ARD });
    document.getElementById("txtRate").focus();
  };

  //#endregion Function

  render() {
    let bolnumTax =
      getTaxNumFromStr(this.state.formData.cmbTaxName) > 0 ? false : true;
    return (
      <div>
        <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Order Item Entry</b>
          </label>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtSrNo"
              label="Sr. No."
              value={this.state.formData.txtSrNo}
              handleOnChange={this.handleOnChange}
              width={80}
              disabled={true}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbItemName"
              label="Item Name*"
              value={this.state.formData.cmbItemName}
              handleOnChange={this.handleOnChange}
              items={this.state.ItemNameList}
              width={380}
              maxLength={100}
              colID="vac_itemname"
              bolVisibleOnAddClickIcon={
                this.props.userPrivilege.Item == "A" ? true : false
              }
              onAddClick={this.onAddClickItem}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtHSN"
            />
          </Grid>
          <Grid item>
            <CtTxt
              id="txtHSN"
              label="HSN"
              value={this.state.formData.txtHSN}
              handleOnChange={this.handleOnChange}
              maxLength={10}
              width={160}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbPacking"
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbPacking"
              label="Packing*"
              value={this.state.formData.cmbPacking}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              items={this.state.ItemNameList}
              colID="vac_unit"
              dataFilter={[
                {
                  filterColID: "vac_itemname",
                  value: this.state.formData.cmbItemName,
                },
              ]}
              width={150}
              maxLength={10}
              nextCtrlID="txtQty"
            />
          </Grid>
          <Grid item>
            <CtBtn
              label="Set TP Rate"
              onClick={this.openTaxPaidRateARD}
              disabled={bolnumTax}
            />
          </Grid>
        </Grid>

        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtQty"
              label="Quantity"
              value={this.state.formData.txtQty}
              handleOnChange={this.handleOnChange}
              maxLength={15}
              width={160}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtRate"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtRate"
              label="Rate*"
              value={this.state.formData.txtRate}
              handleOnChange={this.handleOnChange}
              maxLength={15}
              width={160}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDis"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtBasicAmt"
              label="Basic Amt"
              value={this.state.formData.txtBasicAmt}
              handleOnChange={this.handleOnChange}
              disabled={true}
              width={160}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtDis"
              label="Dis (%)"
              value={this.state.formData.txtDis}
              handleOnChange={this.handleOnChange}
              maxLength={15}
              width={80}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="txtDisAmt"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtDisAmt"
              label="Dis Amt"
              value={this.state.formData.txtDisAmt}
              handleOnChange={this.handleOnChange}
              maxLength={15}
              width={80}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID="cmbTaxName"
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtTaxable"
              label="Taxable"
              value={this.state.formData.txtTaxable}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              disabled={true}
              width={120}
            />
          </Grid>
          <Grid item>
            <CtCmbEditable
              id="cmbTaxName"
              label="Tax Name*"
              value={this.state.formData.cmbTaxName}
              handleOnChange={this.handleOnChange}
              onKeyDown={this.props.onKeyDown}
              items={this.state.TaxNameList}
              colID="vac_taxname"
              maxLength={20}
              width={160}
              nextCtrlID="txtRemark"
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtAmt
              id="txtCGST"
              label="CGST"
              value={this.state.formData.txtCGST}
              handleOnChange={this.handleOnChange}
              disabled={true}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtSGST"
              label="SGST"
              value={this.state.formData.txtSGST}
              handleOnChange={this.handleOnChange}
              disabled={true}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtTxtAmt
              id="txtIGST"
              label="IGST"
              value={this.state.formData.txtIGST}
              handleOnChange={this.handleOnChange}
              disabled={true}
              width={160}
            />
          </Grid>
        </Grid>
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          alignItems="center"
          spacing={2}
          marginTop={0}
        >
          <Grid item>
            <CtTxtNum
              id="txtTotalAmount"
              label="Total Amount"
              value={this.state.formData.txtTotalAmount}
              handleOnChange={this.handleOnChange}
              disabled={true}
              width={160}
            />
          </Grid>
          <Grid item>
            <CtMultiLineText
              id="txtRemark"
              label="Remark"
              value={this.state.formData.txtRemark}
              handleOnChange={this.handleOnChange}
              maxLength={500}
              onKeyDown={this.props.onKeyDown}
              width="330"
              defaultAction={this.saveOrderItem}
              // nextCtrlID="btnAddItem"
            />
          </Grid>
          <Grid
            item
            display={this.props.userPrivilege.Order == "R" ? "none" : "block"}
          >
            <CtBtn
              id="btnAddItem"
              label="Add Item"
              onClick={this.saveOrderItem}
            />
          </Grid>
          <Grid item>
            <CtBtn label="New Item" onClick={this.clearInfo} />
          </Grid>
          <Grid
            item
            display={this.props.userPrivilege.Order !== "M" ? "none" : "block"}
          >
            <CtBtn label="Remove" onClick={this.onDeleteBtnClick} />
          </Grid>
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </div>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenuToProps
)(HoCtToastContainer(withRouter(OrderItemEntry)));
